import React from 'react';

import './DollarValueCell.scss';

export interface DollarValueCellProps {
  getValue: () => number | null;
}

const formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

const DollarValueCell = ({ getValue }: DollarValueCellProps) => {
  const value = getValue();
  const noValue = value === null || value === undefined;

  return (
    <span className={`enkrateia-dollar-value-cell ${noValue ? 'no-value' : ''}`}>
      {noValue ? '-' : formatter.format(value)}
    </span>
  );
};

export default DollarValueCell;
